import React from 'react';

import { Button } from '@appcharge/shared-ui';

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle
} from 'components/ui/card';

interface ISettingsCardProps {
  title: string;
  description?: string;
  children: React.ReactNode;
  onSave?: () => void;
  isSaveDisabled?: boolean;
  isLoading?: boolean;
}

export const SettingsCard: React.FC<ISettingsCardProps> = ({
  title,
  description,
  children,
  onSave,
  isSaveDisabled,
  isLoading
}) => (
  <Card className="w-full border border-base-muted-foreground shadow-none">
    <CardHeader className="flex flex-row items-start justify-between space-y-0 pb-4">
      <div className="flex flex-col gap-1">
        <CardTitle className="text-base font-semibold text-gray-900">
          {title}
        </CardTitle>
        {description && (
          <CardDescription className="text-sm text-gray-500">
            {description}
          </CardDescription>
        )}
      </div>
      {onSave && (
        <Button
          variant="default"
          onClick={onSave}
          disabled={isSaveDisabled}
          isLoading={isLoading}
          className="h-9 min-w-[80px] rounded-lg bg-gray-900 px-4 font-medium text-white hover:bg-gray-800 disabled:bg-gray-400"
        >
          Save
        </Button>
      )}
    </CardHeader>
    <CardContent>{children}</CardContent>
  </Card>
);

